import { useAuth } from "react-oidc-context";
import { Button } from "reactstrap";
import { useEffect, useState } from 'react';


const NotAuthenticated = () => {
    const auth = useAuth();
    const [silentSignInAttempted, setSilentSignInAttempted] = useState(false);

    useEffect(() => {
        if (!auth?.isLoading) {
            async function auto_login() {
                if (!auth.isAuthenticated && !silentSignInAttempted) {
                     await auth.signinSilent();
                } 
            } auto_login();
        }
    }, [auth, silentSignInAttempted])

    return (
        <div data-testid="na" className="m-4">
            <h1>Welcome</h1>
            <p data-testid="not-logged-in">You are not currently logged in.</p>
            <Button
                color="primary"
                data-testid="log-in-btn"
                onClick={() => void auth.signinRedirect()}
            >
                Log in
            </Button>
        </div>
    );
};

export default NotAuthenticated;
